(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Exclusive mode: group each accordion's <details> under one native `name`
  // so the browser closes the open item when another is opened.
  document.querySelectorAll('.accordion--exclusive').forEach((accordion, index) => {
    accordion.querySelectorAll('details').forEach((details) => {
      details.setAttribute('name', `accordion-exclusive-${index}`);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
